var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.779,
    height: 15.955,
    viewBox: "0 0 23.779 15.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.428,
    y1: 0.343,
    x2: 0.748,
    y2: 1.041,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.604,
    y1: 2.233,
    x2: 0.404,
    y2: -1.104,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#239f85",
    stopOpacity: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.02,
    y1: 0.02,
    x2: 1.028,
    y2: 1.028,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.398,
    x2: 0.5,
    y2: 1.398,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.265,
    y1: 0.009,
    x2: 0.578,
    y2: 0.662,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.429,
    y1: -0.286,
    x2: 0.596,
    y2: 1.565,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cash",
    transform: "translate(-154.851 -284.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_160",
    "data-name": "Groupe 160",
    transform: "translate(157.178 284.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143",
    "data-name": "Trac\\xE9 143",
    d: "M135.868,62.842h-19.5a.975.975,0,0,1-.975-.975V51.2a.975.975,0,0,1,.975-.975h19.5a.975.975,0,0,1,.975.975V61.867A.975.975,0,0,1,135.868,62.842Z",
    transform: "translate(-115.392 -50.222)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_144",
    "data-name": "Trac\\xE9 144",
    d: "M136.8,78.748v4.7a.574.574,0,0,0,.46.559,2.181,2.181,0,0,1,1.645,1.566.571.571,0,0,0,.55.425h13.814a.571.571,0,0,0,.55-.425A2.181,2.181,0,0,1,155.464,84a.574.574,0,0,0,.46-.559v-4.7a.574.574,0,0,0-.46-.559,2.181,2.181,0,0,1-1.645-1.566.571.571,0,0,0-.55-.425H139.455a.571.571,0,0,0-.55.425,2.181,2.181,0,0,1-1.645,1.566A.574.574,0,0,0,136.8,78.748Z",
    transform: "translate(-135.636 -74.786)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 3.157,
    cy: 3.157,
    r: 3.157,
    transform: "translate(7.569 3.153)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145",
    "data-name": "Trac\\xE9 145",
    d: "M115.392,224.363v2.178a.975.975,0,0,0,.975.975h19.5a.975.975,0,0,0,.975-.975v-2.178Z",
    transform: "translate(-115.392 -214.897)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_161",
    "data-name": "Groupe 161",
    transform: "translate(156.015 285.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_146",
    "data-name": "Trac\\xE9 146",
    d: "M114.459,93.523h-19.5a.975.975,0,0,1-.975-.975V81.878a.975.975,0,0,1,.975-.975h19.5a.975.975,0,0,1,.975.975V92.548A.975.975,0,0,1,114.459,93.523Z",
    transform: "translate(-93.983 -80.903)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_147",
    "data-name": "Trac\\xE9 147",
    d: "M115.392,109.429v4.7a.574.574,0,0,0,.46.559,2.181,2.181,0,0,1,1.645,1.566.571.571,0,0,0,.55.425h13.814a.571.571,0,0,0,.55-.425,2.181,2.181,0,0,1,1.645-1.566.574.574,0,0,0,.46-.559v-4.7a.574.574,0,0,0-.46-.559,2.181,2.181,0,0,1-1.645-1.566.571.571,0,0,0-.55-.425H118.047a.571.571,0,0,0-.55.425,2.181,2.181,0,0,1-1.645,1.566A.574.574,0,0,0,115.392,109.429Z",
    transform: "translate(-114.228 -105.467)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 3.157,
    cy: 3.157,
    r: 3.157,
    transform: "translate(7.569 3.153)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_148",
    "data-name": "Trac\\xE9 148",
    d: "M93.983,255.045v2.178a.975.975,0,0,0,.975.975h19.5a.975.975,0,0,0,.975-.975v-2.178Z",
    transform: "translate(-93.983 -245.578)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162",
    "data-name": "Groupe 162",
    transform: "translate(154.851 287.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_149",
    "data-name": "Trac\\xE9 149",
    d: "M93.05,124.2h-19.5a.975.975,0,0,1-.975-.975V112.559a.975.975,0,0,1,.975-.975h19.5a.975.975,0,0,1,.975.975v10.669a.975.975,0,0,1-.975.975Z",
    transform: "translate(-72.574 -111.584)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_150",
    "data-name": "Trac\\xE9 150",
    d: "M93.983,140.11v4.7a.574.574,0,0,0,.46.559,2.181,2.181,0,0,1,1.645,1.566.571.571,0,0,0,.55.425h13.814a.571.571,0,0,0,.55-.425,2.181,2.181,0,0,1,1.645-1.566.574.574,0,0,0,.46-.559v-4.7a.574.574,0,0,0-.46-.559A2.181,2.181,0,0,1,111,137.985a.571.571,0,0,0-.55-.425H96.638a.571.571,0,0,0-.55.425,2.181,2.181,0,0,1-1.645,1.566A.574.574,0,0,0,93.983,140.11Z",
    transform: "translate(-92.819 -136.148)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 3.157,
    cy: 3.157,
    r: 3.157,
    transform: "translate(7.569 3.153)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M72.574,285.726V287.9a.975.975,0,0,0,.975.975h19.5a.975.975,0,0,0,.975-.975v-2.178Z",
    transform: "translate(-72.574 -276.26)",
    fill: "url(#linear-gradient-4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.1866da2b.svg";
export { ForwardRef as ReactComponent };